import Button from 'devextreme-react/button';
import { showErrorMessage } from '../../../../utils/messages';
import { useState } from 'react';
import { useSaveCabinetInstallerScheduleDeliveryScriptForm } from '../api/save-cabinetInstallerScheduleDeliveryScriptForm';

const CabinetInstallerScheduleDeliveryScriptForm: React.FC<{
    retailOrderID: number,
    retailOrderNumber: string,
    onClosePopup: () => void,
    onCheckboxChange: (checked: boolean) => void,
    onSubmit?: () => void
}> = ({ retailOrderID, retailOrderNumber, onClosePopup, onCheckboxChange, onSubmit }) => {

    const initialFormState = {
        closingConfirmedDateTextbox: '',
        closingCustomerNameTextbox: '',
        closingTakeCareCheckbox: false,
        closingThanksCheckbox: false,
        confirmingDetailsJustToConfirmCheckbox: false,
        confirmingExplainCheckbox: false,
        confirmingExplainTextbox: '',
        confirmingIfTheCustomerCheckbox: false,
        confirmingMentionCheckbox: false,
        greetingCompanyNameTextbox: '',
        greetingCustomerNameTextbox: '',
        greetingGoodMorningCheckbox: false,
        greetingHiCustomerNameCheckbox: false,
        greetingHiCustomerNameTextbox: '',
        greetingYourNameTextbox: '',
        ifTheCustomerExcellentCheckbox: false,
        ifTheCustomerFirstDateOptionsTextbox: '',
        ifTheCustomerGreatCheckbox: false,
        ifTheCustomerHereAreAFewDatesCheckbox: false,
        ifTheCustomerOfferPreferenceTextbox: '',
        ifTheCustomerPerfectCheckbox: false,
        ifTheCustomerSecondDateOptionsTextbox: '',
        ifTheCustomerThirdDateOptionsTextbox: '',
        installationAdultOverCheckbox: false,
        installationBeforeCheckbox: false,
        installationClearCheckbox: false,
        installationDuringInstallationCheckbox: false,
        installationEmptyCabinetsCheckbox: false,
        installationIsThanksCheckbox: false,
        installationIsThereSpecificCheckbox: false,
        installationKeepChildrenCheckbox: false,
        installationRelocateCheckbox: false,
        installationSetupCheckbox: false,
        installationTurnOffCheckbox: false,
        justToConfirmCustomerAddressTextbox: '',
        justToConfirmTextbox: '',
        justToConfirmTimeRangeTextbox: '',
        notesTextbox: '',
        schedulingDeliveryGreatCheckbox: false
    };

    const [formState, setFormState] = useState(initialFormState);

    const saveChangeOrderScriptForm = useSaveCabinetInstallerScheduleDeliveryScriptForm(
        {
            formObject: {
                retailOrderID,
                retailOrderNo: retailOrderNumber,
                ...formState
            }
        },
        (result) => {
            onClosePopup();
            onCheckboxChange(true);
            if (onSubmit !== undefined) onSubmit!();
        },
        (error) => showErrorMessage(error)
    );

    const handleTextInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setFormState((prevState) => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleReset = () => {
        setFormState(initialFormState);
    };

    return (
        <div>
            <div className='main-header'>
                <h1>Cabinets Call Script – Installer Schedule Delivery and Installation</h1>
            </div>
            <div className='section-container'>
                <div className='sub-header-top-line'></div>
                <div className='sub-header'><span>Greeting</span></div>
                <div className='section-row'>
                    <input type="CheckBox"
                        checked={formState.greetingGoodMorningCheckbox} onChange={(e) => setFormState({ ...formState, greetingGoodMorningCheckbox: e.target.checked })} />
                    <span className='standard-margin-left-distance'>
                        “Good [morning/afternoon], this is <i>(Your Name)</i>
                    </span>
                    <span className='standard-margin-left-distance'>
                        <input
                            type="text"
                            name="greetingYourNameTextbox"
                            value={formState.greetingYourNameTextbox}
                            onChange={handleTextInputChange}
                        />
                    </span>

                    <span className='standard-margin-left-distance'>
                        from <i>(Company Name)</i>
                    </span>
                    <span className='standard-margin-left-distance'>
                        <input
                            type="text"
                            name="greetingCompanyNameTextbox"
                            value={formState.greetingCompanyNameTextbox}
                            onChange={handleTextInputChange}
                        />
                    </span>
                    <span className='standard-margin-top-distance'>
                        . Am I speaking with (Customer’s Name)
                    </span>
                    <span className='standard-margin-left-distance standard-margin-top-distance'>
                        <input
                            type="text"
                            name="greetingCustomerNameTextbox"
                            value={formState.greetingCustomerNameTextbox}
                            onChange={handleTextInputChange}
                        />
                        ?"
                    </span>
                </div>
                <div className='section-row'>
                    <input type="CheckBox"
                        checked={formState.greetingHiCustomerNameCheckbox} onChange={(e) => setFormState({ ...formState, greetingHiCustomerNameCheckbox: e.target.checked })} />
                    <span className='standard-margin-left-distance'>
                        Hi <i>(Customer's Name)</i>
                    </span>
                    <span className='standard-margin-left-distance'>
                        <input
                            type="text"
                            name="greetingHiCustomerNameTextbox"
                            value={formState.greetingHiCustomerNameTextbox}
                            onChange={handleTextInputChange}
                        />
                    </span>
                    <span className='standard-margin-left-distance'>
                        I’m calling to schedule your cabinet delivery and
                        installation.                    </span>
                    <span className='standard-margin-left-distance'>
                        How are you today?”
                    </span>
                </div>
            </div>

            <div className='section-container'>
                <div className='sub-header-top-line'></div>
                <div className='sub-header'><span>Scheduling Delivery and Installation:</span></div>
                <div className='section-row'>
                    <label>
                        <input type="CheckBox"
                            checked={formState.schedulingDeliveryGreatCheckbox} onChange={(e) => setFormState({ ...formState, schedulingDeliveryGreatCheckbox: e.target.checked })} />
                        “Great! We offer a few different options for delivery and installation. Do you have a specific date or
                        timeframe in mind when you’d like to have the cabinets delivered and installed?”
                    </label>
                </div>
            </div>

            <div className='section-container'>
                <div className='sub-header-top-line'></div>
                <div className='sub-header'><span>If the Customer Provides a Date:</span></div>
                <div className='section-row'>
                    <span>
                        <label>
                            <input type="CheckBox"
                                checked={formState.ifTheCustomerPerfectCheckbox} onChange={(e) => setFormState({ ...formState, ifTheCustomerPerfectCheckbox: e.target.checked })} />
                            “Perfect, we have availability on (offer 2-3 options based on their preference)
                        </label>
                    </span>
                    <span className='standard-margin-left-distance'>
                        <input
                            type="text"
                            name="ifTheCustomerOfferPreferenceTextbox"
                            value={formState.ifTheCustomerOfferPreferenceTextbox}
                            onChange={handleTextInputChange}
                        />
                    </span>
                    <span className='standard-margin-left-distance'>
                        [Mention how many days it will take to complete installation] Which of these would work best for you?”
                    </span>
                </div>
                <div className='section-row'>
                    <span>
                        <label>
                            <input type="CheckBox"
                                checked={formState.ifTheCustomerExcellentCheckbox} onChange={(e) => setFormState({ ...formState, ifTheCustomerExcellentCheckbox: e.target.checked })} />
                            <span className='standard-margin-left-distance'>
                                “Excellent!
                            </span>
                        </label>
                    </span>

                </div>
            </div>

            <div className='section-container'>
                <div className='sub-header-top-line'></div>
                <div className='sub-header'><span>If the Customer Needs Options:</span></div>
                <div className='section-row'>
                    <span>
                        <label>
                            <input type="CheckBox"
                                checked={formState.ifTheCustomerHereAreAFewDatesCheckbox} onChange={(e) => setFormState({ ...formState, ifTheCustomerHereAreAFewDatesCheckbox: e.target.checked })} />
                            “Here are a few dates we currently have available: <i>(list 2-3 date options)</i>
                        </label>
                    </span>
                    <span className='standard-margin-left-distance'>
                        <input
                            type="text"
                            name="ifTheCustomerFirstDateOptionsTextbox"
                            value={formState.ifTheCustomerFirstDateOptionsTextbox}
                            onChange={handleTextInputChange}
                        />
                    </span>
                    <span className='standard-margin-left-distance'>
                        <input
                            type="text"
                            name="ifTheCustomerSecondDateOptionsTextbox"
                            value={formState.ifTheCustomerSecondDateOptionsTextbox}
                            onChange={handleTextInputChange}
                        />,
                    </span>
                    <span className='standard-margin-left-distance'>
                        <input
                            type="text"
                            name="ifTheCustomerThirdDateOptionsTextbox"
                            value={formState.ifTheCustomerThirdDateOptionsTextbox}
                            onChange={handleTextInputChange}
                        />
                        . [mention how many days it will take to complete installation]
                    </span>
                    <span className='standard-margin-left-distance'>
                        Do any of these work for you?”
                    </span>
                </div>
                <div className='section-row'>
                    <span>
                        <label>
                            <input type="CheckBox"
                                checked={formState.ifTheCustomerGreatCheckbox} onChange={(e) => setFormState({ ...formState, ifTheCustomerGreatCheckbox: e.target.checked })} />
                            <span className='standard-margin-left-distance'>
                                “Great!
                            </span>
                        </label>
                    </span>
                </div>
            </div>

            <div className='section-container'>
                <div className='sub-header-top-line'></div>
                <div className='sub-header'><span>Confirming the Details:</span></div>
                <div className='section-row'>
                    <span>
                        <label>
                            <input type="CheckBox"
                                checked={formState.confirmingDetailsJustToConfirmCheckbox} onChange={(e) => setFormState({ ...formState, confirmingDetailsJustToConfirmCheckbox: e.target.checked })} />
                            <span className='standard-margin-left-distance'>
                                “Just to confirm, we’ll be delivering and installing your cabinets on (confirmed date)
                            </span>
                        </label>
                    </span>

                    <span className='standard-margin-left-distance'>
                        <input
                            type="text"
                            name="justToConfirmTextbox"
                            value={formState.justToConfirmTextbox}
                            onChange={handleTextInputChange}
                        />.
                    </span>
                    <span className=' standard-margin-top-distance'>
                        at <i>(customer’s address)</i>
                    </span>
                    <span className='standard-margin-left-distance standard-margin-top-distance'>
                        <input
                            type="text"
                            name="justToConfirmCustomerAddressTextbox"
                            value={formState.justToConfirmCustomerAddressTextbox}
                            onChange={handleTextInputChange}
                        />.
                    </span>
                    <span className=' standard-margin-top-distance'>
                        Our team will arrive between (time range)
                    </span>
                    <span className='standard-margin-left-distance standard-margin-top-distance'>
                        <input
                            type="text"
                            name="justToConfirmTimeRangeTextbox"
                            value={formState.justToConfirmTimeRangeTextbox}
                            onChange={handleTextInputChange}
                        />.
                    </span>
                </div>
                <div className='section-row'>
                    <span>
                        <label>
                            <input type="CheckBox"
                                checked={formState.confirmingExplainCheckbox} onChange={(e) => setFormState({ ...formState, confirmingExplainCheckbox: e.target.checked })} />
                            <span className='standard-margin-left-distance'>
                                Explain what is happening each day of installation, e.g. “On the scheduled start of installation, we
                                will pick up your cabinets from Home Outlet and deliver to your address. We will perform a quality
                                check to ensure that there are no damages or missing items. The following day we will…. and on
                                the last day of installation, scheduled for
                            </span>
                            <span className='standard-margin-left-distance standard-margin-top-distance'>
                                <input
                                    type="text"
                                    name="confirmingExplainTextbox"
                                    value={formState.confirmingExplainTextbox}
                                    onChange={handleTextInputChange}
                                />,
                            </span>
                            <span className='standard-margin-left-distance standard-margin-top-distance'>
                                we will clean up and ask for your signature to confirm completion of install.”
                            </span>
                        </label>
                    </span>
                </div>
                <div className='section-row'>
                    <span>
                        <label>
                            <input type="CheckBox"
                                checked={formState.confirmingMentionCheckbox} onChange={(e) => setFormState({ ...formState, confirmingMentionCheckbox: e.target.checked })} />
                            <span className='standard-margin-left-distance'>
                                Mention any additional services you are providing, e.g. remove and haul away, disconnect
                                plumbing, reconnect plumbing, electrical work.
                            </span>
                        </label>
                    </span>
                </div>
                <div className='section-row'>
                    <span>
                        <label>
                            <input type="CheckBox"
                                checked={formState.confirmingIfTheCustomerCheckbox} onChange={(e) => setFormState({ ...formState, confirmingIfTheCustomerCheckbox: e.target.checked })} />
                            <span className='standard-margin-left-distance'>
                                If customer has also purchased countertops from Home Outlet: “We see that you have also
                                purchased countertops, as Home Outlet’s service provider, we will ensure that your countertop
                                installer is informed for a seamless transition from your cabinet install to your countertop
                                project.”
                            </span>
                        </label>
                    </span>
                </div>
            </div>


            <div className='section-container'>
                <div className='sub-header-top-line'></div>
                <div className='sub-header'><span>Confirming the Details:</span></div>
                <div className='section-row'>
                    <span>
                        <label>
                            <input type="CheckBox"
                                checked={formState.installationBeforeCheckbox} onChange={(e) => setFormState({ ...formState, installationBeforeCheckbox: e.target.checked })} />
                            <span className='standard-margin-left-distance'>
                                “Before installation, please make sure to:”
                            </span>
                        </label>
                    </span>

                    <div className='section-row-section-hint'>
                        <label>
                            <input type="CheckBox" checked={formState.installationEmptyCabinetsCheckbox} onChange={(e) => setFormState({ ...formState, installationEmptyCabinetsCheckbox: e.target.checked })} />
                            “Empty cabinets”
                        </label>
                    </div>

                    <div className='section-row-section-hint'>
                        <label>
                            <input type="CheckBox" checked={formState.installationSetupCheckbox} onChange={(e) => setFormState({ ...formState, installationSetupCheckbox: e.target.checked })} />
                            “Set up a temporary kitchen – you will be without a kitchen for the duration of the installation so
                            it’s recommended to create a space with a small fridge, microwave, and water source; stock
                            disposable utensils and pre-plan meals”
                        </label>
                    </div>

                    <div className='section-row-section-hint'>
                        <label>
                            <input type="CheckBox" checked={formState.installationClearCheckbox} onChange={(e) => setFormState({ ...formState, installationClearCheckbox: e.target.checked })} />
                            “Clear off countertops, take down wall hangings, and move furniture away from adjacent walls”
                        </label>
                    </div>

                    <div className='section-row-section-hint'>
                        <label>
                            <input type="CheckBox" checked={formState.installationRelocateCheckbox} onChange={(e) => setFormState({ ...formState, installationRelocateCheckbox: e.target.checked })} />
                            “Relocate pets and designate a safe storage area for your new cabinets”
                        </label>
                    </div>

                </div>

                <div className='section-row'>
                    <span>
                        <label>
                            <input type="CheckBox"
                                checked={formState.installationDuringInstallationCheckbox} onChange={(e) => setFormState({ ...formState, installationDuringInstallationCheckbox: e.target.checked })} />
                            <span className='standard-margin-left-distance'>
                                “During Installation, please ensure that:”
                            </span>
                        </label>
                    </span>

                    <div className='section-row-section-hint'>
                        <label>
                            <input type="CheckBox" checked={formState.installationAdultOverCheckbox} onChange={(e) => setFormState({ ...formState, installationAdultOverCheckbox: e.target.checked })} />
                            “An adult over the age of 18 with decision-making authority is present for the duration of the
                            installation”
                        </label>
                    </div>

                    <div className='section-row-section-hint'>
                        <label>
                            <input type="CheckBox" checked={formState.installationKeepChildrenCheckbox} onChange={(e) => setFormState({ ...formState, installationKeepChildrenCheckbox: e.target.checked })} />
                            “Keep children and pets out of the work area”
                        </label>
                    </div>

                    <div className='section-row-section-hint'>
                        <label>
                            <input type="CheckBox" checked={formState.installationTurnOffCheckbox} onChange={(e) => setFormState({ ...formState, installationTurnOffCheckbox: e.target.checked })} />
                            “Turn off central heating/AC during sanding to limit dust spread”
                        </label>
                    </div>
                </div>

                <div className='section-row'>
                    <span>
                        <label>
                            <input type="CheckBox"
                                checked={formState.installationIsThereSpecificCheckbox} onChange={(e) => setFormState({ ...formState, installationIsThereSpecificCheckbox: e.target.checked })} />
                            <span className='standard-margin-left-distance'>
                                “Is there anything specific you’d like us to know before the installation crew arrives?”
                            </span>
                        </label>
                    </span>
                </div>

                <div className='section-row'>
                    <span>
                        <label>
                            <input type="CheckBox"
                                checked={formState.installationIsThanksCheckbox} onChange={(e) => setFormState({ ...formState, installationIsThanksCheckbox: e.target.checked })} />
                            <span className='standard-margin-left-distance'>
                                “Got it, thank you for letting us know. Our crew will take care of everything. You’ll receive an email
                                and text soon with information about your installation appointment that includes a prep for install
                                checklist with some details I reviewed with you today. You’ll also receive a reminder email and text
                                the day before with, and if you have any questions in the meantime, don’t hesitate to reach out to
                                us.”
                            </span>
                        </label>
                    </span>
                </div>
            </div>

            <div className='section-container'>
                <div className='sub-header-top-line'></div>
                <div className='sub-header'><span>Closing:</span></div>

                <div className='section-row'>
                    <span>
                        <label>
                            <input type="CheckBox"
                                checked={formState.closingThanksCheckbox} onChange={(e) => setFormState({ ...formState, closingThanksCheckbox: e.target.checked })} />
                            <span className='standard-margin-left-distance'>
                                “Thank you for your time, (Customer’s Name)
                            </span>
                        </label>
                    </span>
                    <span className='standard-margin-left-distance'>
                        <input
                            type="text"
                            name="closingCustomerNameTextbox"
                            value={formState.closingCustomerNameTextbox}
                            onChange={handleTextInputChange}
                        />
                    </span>
                    <span>
                        We look forward to delivering and installing
                    </span>
                    <span className="standard-margin-top-distance">
                        your cabinets on <i>(confirmed date)</i>
                    </span>
                    <span className='standard-margin-left-distance standard-margin-top-distance'>
                        <input
                            type="text"
                            name="closingConfirmedDateTextbox"
                            value={formState.closingConfirmedDateTextbox}
                            onChange={handleTextInputChange}
                        />
                    </span>
                    <span className='standard-margin-top-distance'>
                        . Have a great day!”
                    </span>
                </div>
                <div className='section-row'>
                    <span>
                        <label>
                            <input type="CheckBox"
                                checked={formState.closingTakeCareCheckbox} onChange={(e) => setFormState({ ...formState, closingTakeCareCheckbox: e.target.checked })} />
                            <span className='standard-margin-left-distance'>
                            “Take care! Goodbye!”
                            </span>
                        </label>
                    </span>
                </div>
                <div className='section-row'>
                    Notes:
                    <textarea
                        className='input-fullsize-large-height'
                        value={formState.notesTextbox}
                        onChange={handleTextInputChange}
                        placeholder="Note"
                        name='notesTextbox'
                        rows={5}
                        cols={40}
                    />
                </div>
            </div>

            <div className='button-container'>
                <Button
                    text="Reset"
                    className='reset-button'
                    type="danger"
                    onClick={(e) => {
                        handleReset()
                    }} >
                </Button>

                <Button
                    text="Save Changes"
                    className="save-button"
                    onClick={(e) => {
                        saveChangeOrderScriptForm.mutate();
                    }} >
                </Button>
            </div>
        </div >
    );
};

export default CabinetInstallerScheduleDeliveryScriptForm;
